"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var combineLearningPanelFreeUrl_1 = __importDefault(require("./combineLearningPanelFreeUrl"));
var rest_1 = __importDefault(require("../../../rest"));
var leaderboards_1 = require("../../mock/leaderboards");
var LeaderboardAPIs = {
    getLeaderboardLessons: function () {
        return rest_1.default.get({
            mockFunc: function () { return leaderboards_1.mockLeaderboardLessons; },
            url: (0, combineLearningPanelFreeUrl_1.default)('/leaderboards/get-lessons'),
        });
    },
    getLeaderboardUsers: function () {
        return rest_1.default.get({
            mockFunc: function () { return leaderboards_1.mockLeaderboardUsers; },
            url: (0, combineLearningPanelFreeUrl_1.default)('/leaderboards/get-users'),
        });
    },
    getLeaderboardChallenges: function () {
        return rest_1.default.get({
            mockFunc: function () { return leaderboards_1.mockLeaderboardChallenges; },
            url: (0, combineLearningPanelFreeUrl_1.default)('/leaderboards/get-challenges'),
        });
    },
    getLeaderboardAssessments: function () {
        return rest_1.default.get({
            mockFunc: function () { return leaderboards_1.mockLeaderboardAssessments; },
            url: (0, combineLearningPanelFreeUrl_1.default)('/leaderboards/get-assessments'),
        });
    },
    getHomePageData: function () {
        return rest_1.default.get({
            mockFunc: function () { return leaderboards_1.mockDashboardData; },
            url: (0, combineLearningPanelFreeUrl_1.default)('/leaderboards/dashboard-data'),
        });
    },
};
exports.default = LeaderboardAPIs;
